// RICS Survey PDF Constants

// RICS Section definitions
export const SECTIONS = {
  D: {
    name: 'Outside the property',
    categories: {
      D1: 'Chimney stacks',
      D2: 'Roof coverings',
      D3: 'Rainwater pipes and gutters',
      D4: 'Main walls',
      D5: 'Windows',
      D6: 'Outside doors',
      D7: 'Conservatory and porches',
      D8: 'Other joinery and finishes',
      D9: 'Other'
    }
  },
  E: {
    name: 'Inside the property',
    categories: {
      E1: 'Roof structure',
      E2: 'Ceilings',
      E3: 'Walls and partitions',
      E4: 'Floors',
      E5: 'Fireplaces, chimney breasts and flues',
      E6: 'Built-in fittings',
      E7: 'Woodwork',
      E8: 'Bathroom fittings',
      E9: 'Other'
    }
  },
  F: {
    name: 'Services',
    categories: {
      F1: 'Electricity',
      F2: 'Gas/oil',
      F3: 'Water',
      F4: 'Heating',
      F5: 'Water heating',
      F6: 'Drainage',
      F7: 'Common services'
    }
  },
  G: {
    name: 'Grounds',
    categories: {
      G1: 'Garage',
      G2: 'Outbuildings',
      G3: 'Other'
    }
  }
}

// Color scheme (RICS compliant)
export const COLORS = {
  purple: '#5B2D8C',
  purpleLight: '#8B6AAF',
  green: '#92D050',      // Rating 1 - No repair needed
  orange: '#FFC000',     // Rating 2 - Minor repairs
  red: '#FF0000',        // Rating 3 - Serious defects
  white: '#FFFFFF',
  black: '#000000',
  grey: '#E0E0E0',
  lightGrey: '#F5F5F5',
  darkGrey: '#666666'
}

// Rating configuration
export const RATINGS = {
  '1': { color: COLORS.green, textColor: COLORS.white, label: 'No repair needed' },
  '2': { color: COLORS.orange, textColor: COLORS.white, label: 'Minor repairs' },
  '3': { color: COLORS.red, textColor: COLORS.white, label: 'Serious defects' },
  'NI': { color: COLORS.white, textColor: COLORS.black, label: 'Not inspected' }
}

// Page dimensions (A4 in points: 595 x 842)
export const DIMENSIONS = {
  page: {
    width: 595,
    height: 842
  },
  margin: {
    top: 40,
    right: 40,
    bottom: 50,
    left: 40
  },
  sectionBox: {
    width: 50,
    height: 60
  },
  ratingCircle: {
    size: 20
  },
  photo: {
    maxWidth: 200,
    maxHeight: 160
  }
}

// Worker URL for fetching images
export { API_URL as WORKER_URL } from '../config/env'
